// extracted by mini-css-extract-plugin
export var cardContainer = "MediumPosts-module--card-container--pAcAw";
export var cdsAssistiveText = "MediumPosts-module--cds--assistive-text--953qG";
export var cdsVisuallyHidden = "MediumPosts-module--cds--visually-hidden--cJLLP";
export var hideFeedback = "MediumPosts-module--hide-feedback--lCsj5";
export var image = "MediumPosts-module--image--v35Rb";
export var showFeedback = "MediumPosts-module--show-feedback--oVuoD";
export var skeleton = "MediumPosts-module--skeleton--vtlzO";